import { useGetHeaderInfoQuery } from '@core/app/api/profileApi'


const getInitialIsEmployee = (): boolean | null => {
    if (typeof window === 'undefined') return null
    return window.employeeData ? true : null
}

const useIsEmployee = () => {
    const { data: headerInfo, isLoading } = useGetHeaderInfoQuery({})
    const isEmployee = headerInfo ? headerInfo?.data?.Substitute === 1 : getInitialIsEmployee()

    return { isEmployee, isLoading }
}

export default useIsEmployee
